import {useContext} from 'react';

import {TeamOrgQuery} from '../../generated/graphql';
import {isAccountMatchingOrg} from '../../util/accounts/pricing';
import {useCurrentTeamOrg} from '../../util/nudgeBars';
import {GlobalBannerContext} from './GlobalBannerContextProvider';
import {GlobalBannerState} from './types';

export function useGetFilteredGlobalBannerStates(): GlobalBannerState[] | null {
  const currentTeamOrg: TeamOrgQuery | null = useCurrentTeamOrg();

  const {states} = useContext(GlobalBannerContext);
  if (states == null || states.length === 0) {
    return null;
  }

  const filteredStates =
    currentTeamOrg != null
      ? states.filter(state => {
          return isAccountMatchingOrg(
            state.account,
            currentTeamOrg.entity?.organization
          );
        })
      : states;

  if (filteredStates.length === 0) {
    return null;
  }

  return filteredStates;
}

export function useGetFilteredGlobalBannerStatesForSingleOrg(): GlobalBannerState | null {
  const currentTeamOrg: TeamOrgQuery | null = useCurrentTeamOrg();

  const {states} = useContext(GlobalBannerContext);
  if (states == null || states.length === 0) {
    return null;
  }

  const filteredStates =
    currentTeamOrg != null
      ? states.filter(state => {
          return isAccountMatchingOrg(
            state.account,
            currentTeamOrg.entity?.organization
          );
        })
      : states;

  if (filteredStates.length !== 1) {
    return null;
  }

  return filteredStates[0];
}
